import { createFileRoute } from '@tanstack/react-router'
import { EmptyState, PageHeader } from '../../admin/ui'

export const Route = createFileRoute('/admin/users')({
  component: Users,
})

function Users() {
  return (
    <>
      <PageHeader kicker="Access" title="Users" />
      <EmptyState
        title="User management is not available yet"
        body="The API does not expose user-management endpoints. Operator accounts are managed in Zitadel for now."
      />
    </>
  )
}
